module.exports = __webpack_public_path__ + "static/img/18013B_5_6_C_20230519_LC.adf46e9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/18013B_5_6_C_20230519_LC.png
// module id = lPuE
// module chunks = 0